import { Box, Stack, IconButton, Typography } from '@mui/material';

import Iconify from '../iconify';

interface Props {
  children?: React.ReactNode;
  hasFilters?: boolean;
  onClearAllFilters?: () => void;
}

export function ActiveFilters({ onClearAllFilters, children, hasFilters }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      aria-label="Active filters"
      role="region"
    >
      <Stack direction="row" alignItems="center">
        <Typography variant="h6" component="h2" sx={{ ml: 1 }}>
          Active Filters
        </Typography>
      </Stack>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {children}
        {hasFilters && (
          <IconButton
            onClick={onClearAllFilters}
            size="small"
            aria-label="Clear all filters"
            sx={{
              '&:focus': {
                outline: '2px solid',
                outlineOffset: '2px',
              },
            }}
          >
            <Iconify icon="solar:trash-bin-trash-bold" />
            <Typography variant="subtitle2" sx={{ ml: 0.5 }}>
              Clear
            </Typography>
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
